var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
var Whatsapp = /** @class */ (function (_super) {
    __extends(Whatsapp, _super);
    function Whatsapp() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.opened = false;
        _this.messageInput = '';
        return _this;
    }
    Object.defineProperty(Whatsapp.prototype, "sanitizedPhone", {
        get: function () {
            return String(this.phone || '').replace(/\D/g, '');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Whatsapp.prototype, "fullMessage", {
        get: function () {
            return [this.message, this.messageInput].filter(Boolean).join(' ').trim();
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Whatsapp.prototype, "propertyContext", {
        get: function () {
            return window.__whatsappPropertyContext || null;
        },
        enumerable: false,
        configurable: true
    });
    Whatsapp.prototype.openWhatsappModal = function () {
        var fn = window.openWhatsapp;
        if (fn) {
            fn(this.sanitizedPhone, this.fullMessage, this.propertyContext);
        }
    };
    Whatsapp.prototype.openWhatspp = function () {
        var encodedMessage = encodeURIComponent(this.fullMessage);
        var whatsUrl = "https://api.whatsapp.com/send?phone=" + this.sanitizedPhone + "&text=" + encodedMessage;
        window.open(whatsUrl, "_blank");
    };
    Whatsapp.prototype.submit = function (e) {
        e.preventDefault();
        if (this.withModal) {
            this.openWhatsappModal();
            return;
        }
        this.openWhatspp();
    };
    Whatsapp.prototype.changeState = function () {
        if (this.withModal) {
            this.openWhatsappModal();
            return;
        }
        if (this.forceopen) {
            this.openWhatspp();
            return;
        }
        this.opened = !this.opened;
    };
    Whatsapp.prototype.chatStyle = function () {
        return {
            display: (this.opened && "block") || (!this.opened && "none")
        };
    };
    __decorate([
        Prop()
    ], Whatsapp.prototype, "phone", void 0);
    __decorate([
        Prop()
    ], Whatsapp.prototype, "message", void 0);
    __decorate([
        Prop()
    ], Whatsapp.prototype, "forceopen", void 0);
    __decorate([
        Prop({ default: false })
    ], Whatsapp.prototype, "withModal", void 0);
    Whatsapp = __decorate([
        Component({
            components: {}
        })
    ], Whatsapp);
    return Whatsapp;
}(Vue));
export default Whatsapp;
